var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.431,
    height: 19,
    viewBox: "0 0 15.431 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.003 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M222.843,154.7a.445.445,0,0,0-.445.445v8.41a.445.445,0,1,0,.89,0v-8.41A.445.445,0,0,0,222.843,154.7Zm0,0",
    transform: "translate(-212.505 -147.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M104.843,154.7a.445.445,0,0,0-.445.445v8.41a.445.445,0,1,0,.89,0v-8.41A.445.445,0,0,0,104.843,154.7Zm0,0",
    transform: "translate(-99.756 -147.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.26,5.655V16.618a2.455,2.455,0,0,0,.653,1.693A2.191,2.191,0,0,0,3.5,19h8.419a2.191,2.191,0,0,0,1.59-.687,2.455,2.455,0,0,0,.653-1.693V5.655a1.7,1.7,0,0,0-.436-3.343H11.45V1.756A1.748,1.748,0,0,0,9.688,0H5.737A1.748,1.748,0,0,0,3.975,1.756v.556H1.7A1.7,1.7,0,0,0,1.26,5.655ZM11.922,18.108H3.5A1.409,1.409,0,0,1,2.15,16.618V5.694H13.274V16.618a1.409,1.409,0,0,1-1.353,1.491ZM4.865,1.756A.857.857,0,0,1,5.737.888H9.688a.857.857,0,0,1,.872.868v.556h-5.7ZM1.7,3.2H13.728a.8.8,0,1,1,0,1.6H1.7a.8.8,0,1,1,0-1.6Zm0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M163.843,154.7a.445.445,0,0,0-.445.445v8.41a.445.445,0,1,0,.89,0v-8.41A.445.445,0,0,0,163.843,154.7Zm0,0",
    transform: "translate(-156.131 -147.821)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/iconDelete.49aa3fa7f091923e2b57303d97a7b1d4.svg";
export { ForwardRef as ReactComponent };